import {GoogleLink} from "../components/auth/google-link";

export const Profile = () => {
    return (
        <>
            <GoogleLink></GoogleLink>
        </>
    );
};
